// extracted by mini-css-extract-plugin
export default {"accordion":"styles_accordion__dsPy8","summary":"styles_summary__tBPtf","expandIconWrapper":"styles_expandIconWrapper__xJvRT"};